module.exports = __webpack_public_path__ + "img/img21.ea87fbac.png";